import {LoadingReducerState} from './loading.interfaces';

export const loadingInitialState: LoadingReducerState = {
    active: false,
    loaderCanCloseAt: 0
};
